import React from "react";

const SecureRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M10 2.75L2.75002 6C2.75002 6 2.00002 17.25 10 17.25C18 17.25 17.25 6 17.25 6L10 2.75Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SecureRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;